import { BaseUrl } from "./APIURL";


//192.168.29.102:8083/dairy-warna/transaction/gateEntry/getGateEntryList
export const getGateEntryAPIURL = BaseUrl + "/transaction/gateEntry/getGateEntryList";

//192.168.29.102:8083/dairy-warna/transaction/gateEntry/saveGateEntry
export const saveGateEntryAPIURL = BaseUrl + "/transaction/gateEntry/saveGateEntry";

//192.168.29.102:8083/dairy-warna/transaction/gateEntry/updateGateEntry
export const updateGateEntryAPIURL = BaseUrl + "/transaction/gateEntry/updateGateEntry";

//192.168.29.102:8083/dairy-warna/transaction/gateEntry/deleteGateEntry?id=1
export const deleteGateEntryAPIURL = BaseUrl + "/transaction/gateEntry/deleteGateEntry";

//192.168.29.102:8083/dairy-warna/transaction/gateEntry/generateQrCode?id=2
export const printGateEntryAPIURL = BaseUrl + "/transaction/gateEntry/generateQrCode";

